import { HelpText } from "components/modals/EventModals/HelpTextModal";
import {
    DAILY,
    EventConfigLimit,
    MONTHLY,
    Patterns,
    WEEKLY,
    YEARLY,
} from "constant";
import { Col, FormControl, InputGroup } from "react-bootstrap";

export type RepeatIntervalValue = {
    value: string;
    errorMessage: string;
};

type RepeatOptionValueType = {
    limit: number;
    validatePattern: RegExp;
};

const RepeatInterval = ({
    repeatIntervalValue,
    onChange,
    repeatOption,
}: {
    repeatIntervalValue: RepeatIntervalValue;
    onChange: Function;
    repeatOption: string;
}) => {
    const repeatOptionValue: Record<string, RepeatOptionValueType> = {
        [DAILY]: {
            limit: EventConfigLimit.REPEAT_DAILY_MAX,
            validatePattern: Patterns.repeatDailyPattern,
        },
        [WEEKLY]: {
            limit: EventConfigLimit.REPEAT_WEEKLY_MAX,
            validatePattern: Patterns.repeatWeeklyPattern,
        },
        [MONTHLY]: {
            limit: EventConfigLimit.REPEAT_MONTHLY_MAX,
            validatePattern: Patterns.repeatMonthlyPattern,
        },
        [YEARLY]: {
            limit: EventConfigLimit.REPEAT_YEARLY_MAX,
            validatePattern: Patterns.repeatYearlyPattern,
        },
    };
    const getTimeUnit = () => {
        if (repeatOption === DAILY) return "day";
        return repeatOption.slice(0, -2).toLowerCase();
    };

    const validateInterval = (value: string) => {
        const intervalPattern = repeatOptionValue[repeatOption].validatePattern;
        if (value && !intervalPattern.test(value)) return true;
        return false;
    };

    return (
        <div className="form-box mb-3">
            <h5 className="mb-4">Repeat Every</h5>
            <InputGroup className="mt-2">
                <FormControl
                    aria-label="repect-every-input"
                    value={repeatIntervalValue.value}
                    onChange={(e) => {
                        const value = e.target.value;
                        if (validateInterval(value)) return;
                        onChange({
                            value: value,
                            errorMessage: value
                                ? ""
                                : "Please enter an interval.",
                        });
                    }}
                />
                <InputGroup.Text>
                    {getTimeUnit().capitalize()}(s)
                </InputGroup.Text>
            </InputGroup>
            <HelpText
                min={1}
                max={repeatOptionValue[repeatOption].limit}
                timeUnit={getTimeUnit()}
            />
            {repeatIntervalValue.errorMessage && (
                <Col sm="12" className="mt-2">
                    <p className="text-danger">
                        {repeatIntervalValue.errorMessage}
                    </p>
                </Col>
            )}
        </div>
    );
};

export default RepeatInterval;
